import { CobblesManagerPage } from "./CobblesManagerPage";

const CobblesManager = () => {
	return <CobblesManagerPage />;
};
export default CobblesManager;
